'use strict';

import { isElement, forEach, debounce } from 'lodash';
import 'jquery-validation';

/* ========================================================================== */

const moduleName = 'validate-form',
	selectors = {
		base: `.js-${moduleName}`,
		submit: `.js-${moduleName}-submit`,
		fields: `.js-${moduleName}-fields`,
		checks: `.js-${moduleName}-checkbox`,
	};

$.validator.addMethod('phoneNL', function (value, element) {
	const testValue = value.replaceAll('-', '').replaceAll(' ', '');

	if (/^(?:0|\+|00)[1-9]\d{8,15}$/.test(testValue)) {
		return true;
	} else {
		return false;
	};
}, "Please enter a valid phone number");

/* ========================================================================== */

export class ValidationForm {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error('No form was found');

			return;
		}

		this.baseElement = baseElement;
		this.submitButton = this.baseElement.querySelector(selectors.submit);

		this._configure();
		this._bindEvents();
	}

	_configure() {
		$(this.baseElement).validate({
			errorPlacement: function (error, element) {
				element.parent().append(error);
			},
			errorElement: "div",
			rules: {
				phoneNumber: {
					required: true,
					phoneNL: true
				}
			},
			onfocusout: function (element) {
				// "eager" validation
				this.element(element);
			},
			// use highlight and unhighlight
			highlight: function (element) {
			},
			unhighlight: function (element) {
			}
		});
	}

	/* ------------------------------------------------------------------------- */

	_bindEvents() {
		// onchange on form
		this.baseElement.addEventListener(
			'input',
			debounce(this._onChangeHandler.bind(this), 100, { 'leading': false, 'trailing': true })
		);
	}

	/* ------------------------------------------------------------------------- */

	_onChangeHandler() {
		this.fields = this.baseElement.querySelectorAll(selectors.fields);
		this.checks = this.baseElement.querySelectorAll(selectors.checks);
		// check if all required fields are filled
		let values = [];
		forEach(this.fields, (field) => values.push(field.value));
		forEach(this.checks, (check) => values.push(check.checked));
		// if so enable the submit button
		this.submitButton.disabled = values.includes('') || values.includes(false);
	}
}

export default ValidationForm;
